import {Reducer} from "redux";
import {IProductContainerState} from "./product";
import {IProductAction, ProductAction} from "./product.actions";

const futureDate = new Date();
futureDate.setFullYear(9999, 11, 31);

const initialState: IProductContainerState = {
    useAssetImage: false,
    timeStamp: new Date(),
    showDepthAsHeight: false,
    productImageUpdating: false,
    productPriceUpdating: false,
    arExistForIOS: false,
    arExistForAndroid: false,
    refreshDate: futureDate,
};

export const productReducer: Reducer<IProductContainerState, IProductAction> = (state = initialState, action) => {
    switch (action.type) {
        case ProductAction.SET_CONFIG: {
            return {
                ...state,
                config: action.config,
            }
        }
        case ProductAction.APPLY_CONFIG: {
            return {
                ...state,
                config: action.config,
            };
        }
        case ProductAction.SET_CONFIG_QUERYSTRING: {
            return {
                ...state,
                config: {
                    ...state.config,
                    queryString: action.queryString
                },
            };
        }
        case ProductAction.SET_DEFAULT_CONFIG_QUERYSTRING: {
            return {
                ...state,
                config: {
                    ...state.config,
                    queryString: action.queryString
                },
            };
        }
        case ProductAction.UPDATE_VARIANT: {
            return {
                ...state,
                config: { ...state.config, sku: action.sku },
            };
        }
        case ProductAction.SET_PRODUCT: {
            return {
                ...state,
                ...action.product,
            };
        }
        case ProductAction.SET_PRODUCT_PRICES: {
            return {
                ...state,
                prices: action.prices,
            };
        }
        case ProductAction.SET_PRODUCT_CYLINDO_IMAGE: {
            return {
                ...state,
                cylindoImageUrl: action.imageUrl,
            };
        }
        case ProductAction.CLEAR_PRODUCT_STATE: {
            //return { useAssetImage: false, timeStamp: new Date(), showDepthAsHeight: false, refreshDate: new Date().setFullYear(9999, 12,31) };

            return {
                ...initialState,
                useAssetImage: false,
                timeStamp: new Date(),
                showDepthAsHeight: false,
                refreshDate: futureDate
            };
        }
        case ProductAction.PRODUCT_IMAGE_UPDATING: {
            return {
                ...state,
                productImageUpdating: action.productImageUpdating,
            }
        }
        case ProductAction.PRODUCT_PRICE_UPDATING: {
            return {
                ...state,
                productPriceUpdating: action.productPriceUpdating
            }
        }
        case ProductAction.SET_AR_URL: {
            return {
                ...state,
                arUrl: action.arUrl
            }
        }
        case ProductAction.SET_AR_AVAILABILITY: {
            return {
                ...state,
                arExistForIOS: action.arExistForIOS,
                arExistForAndroid: action.arExistForAndroid
            }
        }
        case ProductAction.SET_PROFESSIONALS_FROM_PRICE: {
            return {
                ...state,
                professionalsFromPrice: action.professionalsFromPrice
            }
        }
        default: {
            return state;
        }
    }
};
